<template>
 <div>
   <div v-if="isSourceJp">
     <strong :class="cssClass">
       {{fiatReward}} USD
     </strong>
     <span  class="is-7">{{this.$t('widget.rewardInUSD')}}</span>
   </div>
   <div v-else>
     <strong v-if="min || max" :class="cssClass">
       <currency :val="getHalf(min)" v-if="min" :currency="currency" />
       <span v-if="min && max">-</span>
       <currency v-if="max" :val="getHalf(max)" :currency="currency" />
     </strong>
     <strong v-else :class="cssClass">
       {{userRewardPercentage}}{{this.$t('widget.percentOfSalary')}}
     </strong>
     <span  class="is-7">{{titleLabel}}</span>
   </div>
 </div>
</template>

<script>
import Currency from '@/components/general/currency'
import GlobalData from '@/helpers/global-data'
import {mapMutations} from 'vuex'

export default {
  components: {
    Currency
  },
  props: {
    min: {
      type: [Number],
      default: null
    },
    max: {
      type: [Number],
      default: null
    },
    rewardPercentage: {
      type: [Number],
      default: 12
    },
    cssClass: {
      type: String,
      default: 'strong'
    },
    title: {
      type: String,
      default: ''
    },
    referrer: {
      type: Boolean,
      default: false
    },
    currency: {
      type: String,
      default: 'USD'
    },
    isSourceJp: {
      type: Boolean,
      default: false
    },
    fiatReward: {
      type: Number,
      default: 0
    }
  },
  methods: {
    ...mapMutations('jobs', ['setCurrentJobMin', 'setCurrentJobMax', 'setCurrentJobRewardPer', 'clearRewards']),
    getHalf (reward) {
      let actualReward = parseFloat(reward) / 2
      return actualReward
    }
  },
  computed: {
    userRewardPercentage () {
      const f = this.referrer ? GlobalData.referralFraction() : 1
      const other = (this.rewardPercentage / 2)
      return (this.rewardPercentage - other) * f
    },
    titleLabel () {
      return this.title || this.$t('widget.rewardInCrypto')
    }
  },
  mounted () {
    this.clearRewards()
    setTimeout(() => {
      this.setCurrentJobMin({ currentJobMin: this.min, currency: this.currency })
      this.setCurrentJobMax({ currentJobMax: this.max, currency: this.currency })
      this.setCurrentJobRewardPer(this.rewardPercentage)
    }, 1000)
  }
}
</script>
<style lang="scss" scoped>
  .strong {
    font-size: 0.75rem;
    margin-bottom: 0.25rem;
  }
  strong {
    display: block;
  }
  .title {
    margin-bottom: 0.25rem;
  }
  strong.inline {
    display: inline-block !important;
  }
  .normal {
    font-weight: normal;
  }
  .f-14 {
    font-size: 14px;
  }
  .is-7 {
    margin-top: 0;
    color: #111;
    font-size: .75rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/jobs/reward.vue